import { soulApi } from "../api/SoulApi";
import { InfoPlanModel } from "../models/Soul/PlanModel";
import { SoulDataModel } from "../models/Soul/SoulDataModel";

class SoulManager {
  private static instance: SoulManager;

  public static get(): SoulManager {
    if (!this.instance) {
      this.instance = new SoulManager();
    }
    return this.instance;
  }

  async getSoul(): Promise<SoulDataModel | undefined> {
    try {
      const result = await soulApi.soulInfo.request(null);
      return result.data;
    } catch (error) {
      console.error("Error en getSoul:", error);
      return undefined;
    }
  }

  async getSoulPlan(): Promise<InfoPlanModel | undefined> {
    try {
      const result = await soulApi.soulPlan.request(null);
      return result.data;
    } catch (error) {
      console.error("Error en getSoul:", error);
      return undefined;
    }
  }
}

export const soulManager = SoulManager.get();
